import { Link as MuiLink } from "@mui/material";
import React from "react";

const urlRegex = () => {
  const protocol = `(?:https?://)?`;
  const auth = "(?:\\S+(?::\\S*)?@)?";
  const host = "(?:(?:[a-z0-9][-_]*)*[a-z0-9]+)";
  const domain = "(?:\\.(?:[a-z0-9]-*)*[a-z0-9]+)*";
  const tld = `(?:\\.)[a-z]{2,}`;
  const path = '(?:[/?#][^\\s\\u00a1-\\uffff"]*)?';
  const regex = `(?:${protocol}${auth}(?:${host}${domain}${tld})${path})`;
  const result = new RegExp(`(${regex})`, "ig");
  return result;
};

interface LinkifyProps {
  text: string;
  isCurrentUser: boolean;
}

function Linkify({ text, isCurrentUser }: LinkifyProps) {
  const nonCapturingRegex = urlRegex();
  const parts = text.split(nonCapturingRegex);

  const result = parts.map((part, i) => {
    if (!part || !part.match) {
      return null;
    }
    if (part.match(nonCapturingRegex)) {
      // Exclude email addresses
      if (part.includes("@") && !part.includes("/")) {
        return <React.Fragment key={i}>{part}</React.Fragment>;
      }
      const href = part.endsWith(".") ? part.slice(0, -1) : part;
      const protocolPrefix = part.match(/https?:?\/\//) ? "" : "//";
      return (
        <MuiLink
          key={i}
          target="_blank"
          rel="noreferrer"
          href={`${protocolPrefix}${href}`}
          underline="hover"
          sx={{ ...(isCurrentUser ? { color: "#0000EE" } : {}) }}
        >
          {part}
        </MuiLink>
      );
    }
    return <React.Fragment key={i}>{part}</React.Fragment>;
  });

  return <>{result}</>;
}

export default Linkify;
